/**
 * Action Cable events from Pipelines::BuildChannel that should trigger a build refetch.
 */
export enum BuildChannelEvent {
  Updated = "updated",
  Started = "started",
  Finished = "finished",
  Failing = "failing",
  Skipped = "skipped",
  Canceling = "canceling",
  CommitChanged = "commit:changed",
  StepsChanged = "steps:changed",
  PipelineChanged = "pipeline:changed",
  AnnotationsChanged = "annotations:changed",
}

type StepsChangedMessage = { event: BuildChannelEvent.StepsChanged; step_uuids: string[] };

type PipelineChangedMessage = {
  event: BuildChannelEvent.PipelineChanged;
  step_added_uuids: string[];
  step_changed_uuids: string[];
};

export type BuildChannelMessage =
  | {
      event: Exclude<
        BuildChannelEvent,
        BuildChannelEvent.StepsChanged | BuildChannelEvent.PipelineChanged
      >;
    }
  | PipelineChangedMessage
  | StepsChangedMessage;
